import { Trans, useTranslation } from 'react-i18next';

import {
    Anchor,
    Body1,
    Button,
    Image,
    Modal,
    Stack,
} from '@myphx-engineering/phx-design-system';

type PrescryptivePoweredModalProps = {
    opened: boolean;
    toggle: () => void;
};

export const PrescryptivePoweredModal = ({
    opened,
    toggle,
}: PrescryptivePoweredModalProps) => {
    const { t } = useTranslation();

    const handleClick = () => {
        window.location.replace(import.meta.env.VITE_MYPHX_URL);
    };

    return (
        <Modal
            opened={opened}
            onClose={toggle}
            title={t('navbar.prescryptivePowered.modal.title')}
        >
            <Stack gap="lg">
                <Stack gap="xs">
                    <Body1 inline>
                        <Trans
                            i18nKey="navbar.prescryptivePowered.modal.body1"
                            components={{
                                1: (
                                    <Anchor
                                        href={import.meta.env.VITE_MYPHX_URL}
                                    />
                                ),
                            }}
                        />
                    </Body1>

                    <Stack align="center" justify="center">
                        <Image
                            src="/static/libraries/myphx-lib/application-header/myprescryptive-logo.png"
                            w="160"
                            h="60"
                        />
                    </Stack>
                </Stack>

                <Button size="lg" variant="outline" onClick={handleClick}>
                    {t('navbar.prescryptivePowered.modal.buttonText')}
                </Button>
            </Stack>
        </Modal>
    );
};
